import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <svg {...validProps} viewBox={'28 -40 100 100'}>
            <path d='M85.7 54.2S81.9 60 78 60s-7.7-5.8-7.7-5.8-21.2-32.7-25-48.3c-1.2-3.6-1.9-7.3-1.9-11.3C43.4-24.5 58.9-40 78-40s34.6 15.5 34.6 34.6c0 4-.7 7.8-1.9 11.3-3.9 15.6-25 48.3-25 48.3zm-7.7-73c-7.4 0-13.5 6-13.5 13.5S70.6 8.1 78 8.1s13.5-6 13.5-13.5S85.4-18.8 78-18.8z' />
        </svg>
    );
}
SvgComponent.iconName = 'map-pin';

export const MapPinIcon = svgIconWrapper(SvgComponent);
